import {
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Rate} from 'kpc';

var _$tmp0 = {
    'value': 2,
    'disabled': true
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$cc(Rate, _$tmp0);
};